import messages from '../../../locale/messages';
import { containsMalicious, inputDescLimit } from '../../../helpers/textRestriction';

const validate = values => {

    const errors = {}

    if (!values.reviewContent) {
        errors.reviewContent = messages.reviewError1;
    } else if (values?.reviewContent?.length > inputDescLimit) { 
        errors.reviewContent = messages.descriptionFieldRestriction;
    } else if (containsMalicious(values.reviewContent)) {
        errors.reviewContent = messages.invalidInput;;
    }

    if (!values.rating) {
        errors.rating = messages.reviewError2;
    }

    return errors
}

export default validate;